import React, { useState } from "react";
import {
    TextField,
    List,
    ListItemAvatar,
    Avatar,
    ListItemText,
    ListItemButton,
    Stack
} from "@mui/material";

const OperateurPickerList = ({ operateurs = [], selected, onChange, allowNone = false }) => {
    const [search, setSearch] = useState("");

    const filteredOperateurs = operateurs.filter((o) =>
        o.libelle?.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Stack spacing={2}>
            <TextField
                placeholder="Rechercher un opérateur"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                fullWidth
            />

            <List>
                {allowNone && (
                    <ListItemButton selected={!selected} onClick={() => onChange(null)}>
                        <ListItemText primary="Aucun" />
                    </ListItemButton>
                )}

                {filteredOperateurs.map((op) => (
                    <ListItemButton
                        key={op.id}
                        selected={selected === op.id}
                        onClick={() => onChange(op)}
                    >
                        <ListItemAvatar>
                            <Avatar>{op.libelle?.charAt(0) || "?"}</Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={op.libelle ?? op.email} />
                    </ListItemButton>
                ))}
            </List>
        </Stack>
    );
};

export default OperateurPickerList;
